import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoainnnovacab() {



const cardData =
{
  keyword: 'Pune to Goa Innova Cab',

  heading: 'Lotus Cab: Pune to Goa Innova Cab ',

headingDescription:
  "Lotus Cabs provides comfortable and reliable Pune to Goa Innova Cab services for families, groups, corporate travelers, airport transfers, holiday trips, and one-way or round-trip journeys. Our spacious Toyota Innova cabs are perfect for long-distance travel, offering comfortable seating, ample luggage space, and a smooth ride experience. Driven by professional and experienced chauffeurs, every journey ensures safety, punctuality, and convenience. With 24x7 booking support, transparent pricing, doorstep pickup from any location in Pune, clean and well-maintained vehicles, and dependable highway travel, Lotus Cabs makes your Pune to Goa Innova Cab journey comfortable, affordable, and completely hassle-free.",


  top: 'Top Places to Visit in Goa before Traveling to Pune with Lotus Cab',

topPlaces: [
    {
        title: "Betul Beach",
        description:
            "Betul Beach is a quiet fishing village beach in South Goa known for its serene coastline, traditional seafood, and beautiful sunset views. The peaceful surroundings make it perfect for travelers looking to experience authentic Goan culture."
    },
    {
        title: "Netravali Wildlife Sanctuary",
        description:
            "Netravali Wildlife Sanctuary is a hidden gem in South Goa, famous for lush green forests, waterfalls, trekking routes, and rich biodiversity. The sanctuary offers a refreshing experience for travelers interested in nature, photography, and wildlife exploration."
    },
    {
        title: "Cabo de Rama Fort",
        description:
            "Cabo de Rama Fort is a historic fort located on a cliff overlooking the Arabian Sea. Famous for its spectacular ocean views, ancient architecture, and peaceful surroundings, it is an excellent destination for history lovers and sunset photography."
    },
     {
        title: "Grand Island",
        description:
            "Grand Island is one of Goa's most popular adventure destinations, famous for snorkeling, scuba diving, fishing, and exploring vibrant marine life. Surrounded by crystal-clear waters of the Arabian Sea, the island offers an exciting experience for adventure seekers and nature lovers."
    },
    {
        title: "Cotigao Wildlife Sanctuary",
        description:
            "Cotigao Wildlife Sanctuary is one of Goa's oldest wildlife reserves, known for dense forests, diverse wildlife, and beautiful natural landscapes. Visitors can explore walking trails, spot animals and birds, and enjoy the peaceful environment away from crowded tourist areas."
    },
     {
        title: "Kakolem Beach",
        description:
            "Kakolem Beach, also known as Tiger Beach, is a secluded coastal paradise surrounded by cliffs and greenery. Its untouched beauty, peaceful atmosphere, and scenic views make it one of Goa's best offbeat beach destinations."
    },
    {
        title: "Salaulim Dam",
        description:
            "Salaulim Dam is a scenic attraction surrounded by lush greenery and natural landscapes. The unique spillway design, peaceful reservoir, and beautiful gardens make it a relaxing destination for families and nature enthusiasts."
    },
    {
        title: "Hollant Beach",
        description:
            "Hollant Beach is a calm and less crowded beach near Vasco da Gama, known for its shallow waters, peaceful environment, and stunning sunrise views. It is an ideal spot for swimming, photography, and enjoying a relaxing coastal experience."
    },
    {
        title: "Kesarval Spring",
        description:
            "Kesarval Spring is a natural spring near Cortalim known for its scenic surroundings and traditional importance. Surrounded by greenery, the location offers visitors a peaceful escape and a chance to explore Goa's natural attractions."
    },
    {
        title: "Palácio do Deão",
        description:
            "Palácio do Deão is a historic Portuguese-style heritage mansion located in Quepem, Goa. Known for its beautiful architecture, riverside gardens, and cultural significance, the palace offers visitors a glimpse into Goa's colonial-era lifestyle and traditions."
    }
],





"services": [
  {
    "name": "Pune to Goa Innova Cab",
    "description": "Book Pune to Goa Innova cab service for comfortable and hassle-free long-distance travel with your family or group. The spacious Innova offers premium seating, extra luggage space, and smooth highway performance, making it one of the most preferred vehicles for Goa trips. Available for one-way and round-trip journeys with experienced drivers, transparent pricing, and doorstep pickup services for a safe and enjoyable travel experience."
  },
  {
    "name": "Pune to Goa Innova Crysta Cab",
    "description": "Travel in comfort with Pune to Goa Innova Crysta cab service featuring premium interiors, spacious seating, and air-conditioned comfort. Ideal for family vacations, corporate travel, and group tours, the Innova Crysta ensures a smooth journey from Pune to Goa. Professional chauffeurs and flexible travel packages make it an excellent choice for long-distance intercity travel."
  },
  {
    "name": "Pune to Goa Innova Taxi",
    "description": "Reliable Pune to Goa Innova taxi service offering convenient transportation for families and tourists. The vehicle provides comfortable seating for up to seven passengers and ample luggage capacity, making it perfect for beach holidays and sightseeing trips. Enjoy transparent fares, professional drivers, and flexible booking options for a stress-free journey."
  },
  {
    "name": "Pune to Goa Innova Rental",
    "description": "Book Pune to Goa Innova rental for a comfortable road trip with spacious seating and premium travel amenities. Suitable for family vacations, business trips, and weekend getaways, the service includes clean AC vehicles, experienced drivers, and customizable itineraries according to your travel requirements."
  },
  {
    "name": "Pune to Goa Innova Booking",
    "description": "Easy Pune to Goa Innova booking service with instant confirmation and flexible travel plans. Customers can choose one-way, round-trip, and multi-day packages based on their requirements. Well-maintained vehicles and professional chauffeurs ensure a comfortable and memorable travel experience to Goa."
  },
  {
    "name": "Pune to Goa Family Innova",
    "description": "Pune to Goa family Innova service is specially designed for comfortable family travel with spacious seating and extra luggage space. The vehicle is ideal for families with children and senior citizens looking for a safe and relaxing road trip to Goa. Flexible pickup timings and experienced drivers ensure a hassle-free journey."
  },
  {
    "name": "Pune to Goa SUV Cab",
    "description": "Book a Pune to Goa SUV cab for premium and spacious travel with family and friends. SUV vehicles offer comfortable seating, modern amenities, and excellent highway performance, making long-distance travel more enjoyable. Available for holiday trips, sightseeing tours, and corporate travel requirements."
  },
  {
    "name": "Pune to Goa Luxury Innova",
    "description": "Enjoy premium travel with Pune to Goa luxury Innova service featuring superior comfort, spacious interiors, and professional chauffeur service. Perfect for VIP guests, business executives, and families seeking a luxurious and relaxing journey to Goa with customized travel schedules."
  },
  {
    "name": "Pune to Goa Outstation Innova",
    "description": "Pune to Goa outstation Innova service offers reliable long-distance transportation with comfortable seating and experienced drivers. Suitable for family vacations, group tours, and business trips, the service includes transparent pricing and flexible travel packages for a convenient journey."
  },
  {
    "name": "Pune to Goa One Way Innova Cab",
    "description": "Affordable Pune to Goa one way Innova cab service allowing passengers to travel comfortably without paying return charges. Ideal for tourists planning extended stays in Goa, this service provides spacious seating, professional drivers, and transparent one-side pricing."
  },
  {
    "name": "Pune to Goa Round Trip Innova Cab",
    "description": "Book Pune to Goa round trip Innova cab for weekend holidays, family vacations, and business travel. Flexible return schedules and comfortable seating make the journey enjoyable and stress-free. The service is perfect for travelers looking for convenient transportation throughout their Goa trip."
  },
  {
    "name": "Pune to Goa AC Innova",
    "description": "Travel comfortably with Pune to Goa AC Innova service featuring fully air-conditioned vehicles and spacious interiors. The premium vehicle ensures a smooth and relaxing journey, making it ideal for long-distance travel with family and friends."
  },
  {
    "name": "Pune to Goa Innova Fare",
    "description": "Get transparent Pune to Goa Innova fare details with clear pricing based on distance, toll charges, and travel duration. Competitive rates and flexible packages make Innova one of the most popular choices for comfortable family and group travel."
  },
  {
    "name": "Pune to Goa Innova Price",
    "description": "Check Pune to Goa Innova price options for one-way and round-trip travel packages. Affordable pricing, premium comfort, and spacious seating make the Innova an excellent choice for tourists and families planning a Goa vacation."
  },
  {
    "name": "Best Pune to Goa Innova Cab",
    "description": "Best Pune to Goa Innova cab service offering clean vehicles, experienced drivers, and exceptional customer support. Enjoy comfortable long-distance travel with spacious seating, flexible travel plans, and transparent pricing designed to provide a memorable and hassle-free journey to Goa."
  }
],

"tableData": [
  ["Pune to Goa Innova Cab", "Pune to Goa Innova Crysta Cab"],
  ["Pune to Goa Innova Taxi", "Pune to Goa Innova Rental"],
  ["Pune to Goa Innova Booking", "Pune to Goa Family Innova"],
  ["Pune to Goa SUV Cab", "Pune to Goa Luxury Innova"],
  ["Pune to Goa Outstation Innova", "Pune to Goa One Way Innova Cab"],
  ["Pune to Goa Round Trip Innova Cab", "Pune to Goa AC Innova"],
  ["Pune to Goa Innova Fare", "Pune to Goa Innova Price"],
  ["Best Pune to Goa Innova Cab", ""]
],






"whychoose": [
  {
    "WhyChooseheading": "Spacious Innova for Goa Trips",
    "WhyChoosedescription": "Travel comfortably with family and friends in a roomy Toyota Innova or Innova Crysta."
  },
  {
    "WhyChooseheading": "Perfect for Group Travel",
    "WhyChoosedescription": "Ideal seating and luggage capacity make the Innova an excellent choice for Goa vacations."
  },
  {
    "WhyChooseheading": "Affordable Cab Booking",
    "WhyChoosedescription": "Enjoy competitive pricing with transparent fares and no hidden charges."
  },
  {
    "WhyChooseheading": "One Way & Round Trip Options",
    "WhyChoosedescription": "Book an Innova cab for a one-way journey or a complete round-trip package."
  },
  {
    "WhyChooseheading": "Pickup from Anywhere in Pune",
    "WhyChoosedescription": "Convenient pickup services from homes, hotels, offices, airports, and railway stations."
  },
  {
    "WhyChooseheading": "Comfortable AC Vehicles",
    "WhyChoosedescription": "Clean and well-maintained Innova cabs ensure a relaxing long-distance journey."
  },
  {
    "WhyChooseheading": "Experienced Chauffeurs",
    "WhyChoosedescription": "Professional drivers familiar with highway and ghat routes ensure safe travel."
  },
  {
    "WhyChooseheading": "24/7 Booking Support",
    "WhyChoosedescription": "Get quick assistance and instant booking confirmation anytime you need."
  }
]
};

const faqData = [
  {
    question: 'Does Lotus Cab provide Pune to Goa Innova cab service?',
    answer: 'Yes, Lotus Cab offers reliable Pune to Goa Innova cab services for one-way, round-trip, and customized travel plans.'
  },
  {
    question: 'Why should I choose an Innova for a Goa trip?',
    answer: 'The Toyota Innova is ideal for long-distance travel because it offers spacious seating, excellent comfort, and ample luggage capacity.'
  },
  {
    question: 'What is the distance between Pune and Goa?',
    answer: 'The distance from Pune to Goa is approximately 450 km, and the journey usually takes around 8 to 10 hours.'
  },
  {
    question: 'How much does a Pune to Goa Innova cab cost?',
    answer: 'The fare depends on the travel date, trip type, and vehicle model. Lotus Cab provides affordable and transparent pricing.'
  },
  {
    question: 'Can I book an Innova Crysta for my Goa trip?',
    answer: 'Yes, we offer both Toyota Innova and Innova Crysta vehicles for comfortable travel to Goa.'
  },
  {
    question: 'Do you provide pickup from Pune Airport and railway station?',
    answer: 'Yes, Lotus Cab provides pickup services from Pune Airport, railway stations, hotels, and residential locations.'
  },
  {
    question: 'Are toll and parking charges included in the fare?',
    answer: 'Toll charges, parking fees, and state taxes are generally charged separately unless specifically included in the package.'
  },
  {
    question: 'Is the Innova suitable for family and group travel?',
    answer: 'Absolutely. The Innova is one of the most preferred vehicles for family vacations and group trips to Goa.'
  },
  {
    question: 'Can I book an Innova for a round trip to Goa?',
    answer: 'Yes, we provide flexible round-trip packages for customers planning to return from Goa to Pune.'
  },
  {
    question: 'How can I book a Pune to Goa Innova Cab with Lotus Cab?',
    answer: 'Simply share your pickup location, travel date, number of passengers, and preferred Innova model to receive an instant quotation and booking confirmation.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Chetan Pawar',
    feedback: 'With six people and plenty of luggage, the Innova was the perfect vehicle for our Goa trip. The seats were comfortable and the long drive felt effortless.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Shruti Desai',
    feedback: 'I selected the Innova Crysta for our friends vacation because we wanted extra comfort. The journey was smooth, and everyone appreciated the spacious cabin.',
    rating: 5,
  },
];







































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];






const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Innova Cab",
"image": "https://lotuscab.com/assets/images/pune-to-goa-innova-cab.jpg",
"description": "Book Pune to Goa Innova Cab with Lotus Cab for spacious, comfortable, and premium outstation travel. Hire Innova and Innova Crysta cabs for family trips, luxury travel, one way journeys, and long distance rides with professional drivers and 24x7 taxi service.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7215"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹18/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-innova-cab"
}
};








  return (
    <div>
      



<Helmet>
  <title>Pune to Goa Innova Cab | Innova Crysta Taxi Booking | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa Innova Cab with Lotus Cab for safe and comfortable outstation travel. Get Innova, Innova Crysta, and luxury SUV cab services for family trips, one way journeys, and long distance travel at affordable fares."
/>

<meta
 name="keywords"
 content="Pune to Goa Innova Cab, Pune to Goa Innova Crysta Cab, Pune to Goa Innova Taxi, Pune to Goa Innova Rental, Pune to Goa Innova Booking, Pune to Goa Family Innova, Pune to Goa SUV Cab, Pune to Goa Luxury Innova, Pune to Goa Outstation Innova, Pune to Goa One Way Innova Cab, Pune to Goa Innova"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>





 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/106.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoainnnovacab;